<template>
  <div class="plan-selection-step-20676">
    <div class="plan-selection-step-20676__cards">
      <PlanCard20676
        :plan="billing.annualPlan"
        :billing="billing"
        :selected="selectedPlan.id === 'plan_annual'"
        @click="emit('update:selectedPlan', billing.annualPlan)"
      />
      <PlanCard20676
        :plan="billing.monthlyPlan"
        :billing="billing"
        :selected="selectedPlan.id === 'plan_monthly'"
        @click="emit('update:selectedPlan', billing.monthlyPlan)"
      />
    </div>

    <p class="plan-selection-step-20676__info">
      Enjoy 5 days of unlimited access. We'll remind you before your trial ends.
    </p>

    <button
      type="button"
      class="plan-selection-step-20676__continue btns btns--large"
      @click="emit('continue')"
    >
      Continue
    </button>

    <button
      type="button"
      class="plan-selection-step-20676__skip"
      @click="emit('skip')"
    >
      Skip for now
    </button>
  </div>
</template>

<script setup lang="ts">
import type { BillingView, PlanView } from '@/models/billing'

import PlanCard20676 from '@/app/components/onboarding/plan-card-capture/PlanCard20676.vue'

defineProps<{
  billing: BillingView
  selectedPlan: PlanView
}>()

const emit = defineEmits<{
  (e: 'update:selectedPlan', plan: PlanView): void
  (e: 'continue'): void
  (e: 'skip'): void
}>()
</script>

<style scoped lang="scss">
.plan-selection-step-20676 {
  &__cards {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__info {
    margin-top: 20px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: $c-black-3;
  }

  &__continue {
    width: 100%;
    margin-top: 24px;
    background-color: $c-blue-4;
    border-color: $c-blue-4;
    color: $c-white;

    @include hover {
      background-color: $c-blue-4;
      border-color: $c-blue-4;
      color: $c-white;
      opacity: 0.9;
    }
  }

  &__skip {
    display: block;
    margin: 16px auto 0;
    font-size: 14px;
    color: $c-black-3;
    text-decoration: underline;
  }
}
</style>
